export interface StudentProgressEstimateResponseApi {
  completedCost: number | null;
  studentId: string;
}

export let isStudentProgressEstimateResponseDTO = (
  variable: unknown
): variable is StudentProgressEstimateResponseApi => {
  return (
    variable !== undefined &&
    variable !== null &&
    typeof variable === "object" &&
    "completedCost" in variable &&
    (variable.completedCost === null ||
      typeof variable.completedCost === "number") &&
    "studentId" in variable &&
    typeof variable.studentId === "string"
  );
};
